export const CamFunctions = () => [
  { id: "eam", label: "EAM" },
  { id: "mcs", label: "MultiCRM Sync" },
  { id: "lag", label: "LAG" },
  { id: "self_serve", label: "Self Serve" },
  { id: "hms", label: "HMS" },
  { id: "gtmh", label: "GTMH" },
];

export const HMS = "hms";
export const EAM = "eam";
export const LAG = "lag";
export const GTMH = "gtmh";

export default CamFunctions;
